import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Contact from './components/Contact';
import Reviews from './components/Reviews';
import Blog from './components/Blog';
import InvestmentCalculator from './components/InvestmentCalculator';
import './styles/main.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Route path="/contact" component={Contact} />
          <Route path="/reviews" component={Reviews} />
          <Route path="/blog" component={Blog} />
          <Route path="/calculator" component={InvestmentCalculator} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;